import React from 'react';
import { StyleSheet, View, type ViewStyle } from 'react-native';
import { Colors } from '../constants/Colors';
import { TextReg } from './StyledText';

type Props = {
  text: string;
  backgroundColor: string;
  textColor?: string;
  style?: ViewStyle;
};

const formatStatusText = (text: string): string => {
  return text
    .replace(/_/g, ' ')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

export function StatusPill({
  text,
  backgroundColor,
  textColor = Colors.tint,
  style,
}: Props) {
  const formattedText = formatStatusText(text);

  return (
    <View style={[styles.pill, { backgroundColor }, style]}>
      <TextReg style={[styles.text, { color: textColor }]} numberOfLines={1}>
        {formattedText}
      </TextReg>
    </View>
  );
}

const styles = StyleSheet.create({
  pill: {
    paddingHorizontal: 12,
    paddingVertical: 4,
    borderRadius: 12,
    alignSelf: 'flex-start',
    flexShrink: 0,
  },
  text: {
    fontSize: 12,
    fontWeight: '500',
  },
});
